import { Navigate, Outlet } from "react-router-dom";

function RedirectToPage({ url }) {
  return  <Navigate to={url} />;
}

export default RedirectToPage;
